import { ActionError, PromisifiedActionMeta } from 'Interfaces/ActionCreators';
import { NormalizedEntity } from 'Interfaces/Common';
import {
  Requisite,
  RequisiteDeletePayload,
  RequisiteSiblings,
  RequisitesPayload,
} from 'Interfaces/Requisite';
import { createAsyncAction } from 'typesafe-actions';
import { promisifyAsyncAction } from 'Utils/functions';

import {
  CreateRequisitesActionTypes,
  DeleteRequisiteActionTypes,
  DownloadFileByUrlActionTypes,
  GetRequisitesActionTypes,
  UpdateRequisitesActionTypes,
} from './actionTypes';

export const deleteRequisite = createAsyncAction(
  DeleteRequisiteActionTypes.request,
  DeleteRequisiteActionTypes.success,
  DeleteRequisiteActionTypes.failure,
  DeleteRequisiteActionTypes.cancel,
)<
  [RequisiteDeletePayload, PromisifiedActionMeta],
  [RequisiteSiblings, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $deleteRequisite = promisifyAsyncAction(deleteRequisite);

export const getRequisites = createAsyncAction(
  GetRequisitesActionTypes.request,
  GetRequisitesActionTypes.success,
  GetRequisitesActionTypes.failure,
  GetRequisitesActionTypes.cancel,
)<
  [undefined, PromisifiedActionMeta],
  [NormalizedEntity<Requisite>, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $getRequisites = promisifyAsyncAction(getRequisites);

export const createRequisites = createAsyncAction(
  CreateRequisitesActionTypes.request,
  CreateRequisitesActionTypes.success,
  CreateRequisitesActionTypes.failure,
  CreateRequisitesActionTypes.cancel,
)<
  [RequisitesPayload, PromisifiedActionMeta],
  [RequisiteSiblings, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $createRequisites = promisifyAsyncAction(createRequisites);

export const updateRequisites = createAsyncAction(
  UpdateRequisitesActionTypes.request,
  UpdateRequisitesActionTypes.success,
  UpdateRequisitesActionTypes.failure,
  UpdateRequisitesActionTypes.cancel,
)<
  [RequisitesPayload, PromisifiedActionMeta],
  [RequisiteSiblings, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $updateRequisites = promisifyAsyncAction(updateRequisites);

export const downloadFileByUrl = createAsyncAction(
  DownloadFileByUrlActionTypes.request,
  DownloadFileByUrlActionTypes.success,
  DownloadFileByUrlActionTypes.failure,
  DownloadFileByUrlActionTypes.cancel,
)<
  [string, PromisifiedActionMeta],
  [any, PromisifiedActionMeta],
  [ActionError, PromisifiedActionMeta],
  [undefined, PromisifiedActionMeta]
>();

export const $downloadFileByUrl = promisifyAsyncAction(downloadFileByUrl);
